const scrollToHash = (hash) => {
  const target = document?.getElementById(hash.replace('#', ''));
  if (!target) return;

  const stickyHeader = document.querySelector('sticky-header');
  const offset = stickyHeader ? stickyHeader.offsetHeight + 20 : 80;
  const targetPosition =
    target?.getBoundingClientRect()?.top + window.scrollY - offset;

  setTimeout(() => {
    window.scrollTo({ top: targetPosition, behavior: 'smooth' });
  }, 100);
};

// Handle clicks on anchor links
document?.addEventListener('click', (event) => {
  const anchor = event?.target?.closest('a[href^="#"]');
  if (!anchor || !anchor.hash) return;

  event?.preventDefault();
  scrollToHash(anchor.hash);
});

// Scroll to the correct section if the page loads with a hash
window?.addEventListener('DOMContentLoaded', () => {
  if (window.location.hash) {
    scrollToHash(window.location.hash);
  }
});

/*
How to Use This Code
Add id attributes to your sections:
<section id="about">About Us</section>
<section id="services">Our Services</section>

Use anchor links to navigate
<a href="#about">Go to About</a>
<a href="#services">Go to Services</a>
*/
